const STORAGE_KEY = "pageLoaderActive"
const OVERLAY_ID = "page-loader-overlay"

const SLOW_PATH_PATTERNS = [
  /^\/process\/[^/]+\/show\/?$/,
  /^\/project\/\d+\/show\/?$/
]

function getOverlay() {
  return document.getElementById(OVERLAY_ID)
}

export function showPageLoader() {
  const overlay = getOverlay()
  if (!overlay) return

  overlay.classList.add("is-visible")
  overlay.style.display = "flex"
  overlay.setAttribute("aria-busy", "true")
  document.body.classList.add("overflow-hidden")
}

export function hidePageLoader() {
  const overlay = getOverlay()
  if (overlay) {
    overlay.classList.remove("is-visible")
    overlay.style.display = "none"
    overlay.setAttribute("aria-busy", "false")
  }
  document.body.classList.remove("overflow-hidden")
  sessionStorage.removeItem(STORAGE_KEY)
}

function isSlowNavigation(href) {
  if (!href || href.charAt(0) === "#") return false

  try {
    const url = new URL(href, window.location.origin)
    if (url.origin !== window.location.origin) return false

    return SLOW_PATH_PATTERNS.some((pattern) => pattern.test(url.pathname))
  } catch (_error) {
    return false
  }
}

function restoreLoaderFromSession() {
  if (sessionStorage.getItem(STORAGE_KEY) === "1") {
    showPageLoader()
  }
}

function bindNavigationLoader() {
  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href]")
    if (!link || link.target === "_blank" || link.hasAttribute("download")) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    const href = link.getAttribute("href")
    if (!isSlowNavigation(href)) return

    sessionStorage.setItem(STORAGE_KEY, "1")
    showPageLoader()
  })

  document.addEventListener("submit", (event) => {
    const form = event.target
    if (!form || form.target === "_blank") return

    const action = form.getAttribute("action")
    if (!isSlowNavigation(action)) return

    sessionStorage.setItem(STORAGE_KEY, "1")
    showPageLoader()
  })
}

function scheduleHidePageLoader() {
  hidePageLoader()
}

export function initPageLoader() {
  window.showPageLoader = showPageLoader
  window.hidePageLoader = hidePageLoader

  restoreLoaderFromSession()
  bindNavigationLoader()

  document.addEventListener("DOMContentLoaded", scheduleHidePageLoader)
  window.addEventListener("load", scheduleHidePageLoader)
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) scheduleHidePageLoader()
  })

  if (document.readyState === "interactive" || document.readyState === "complete") {
    scheduleHidePageLoader()
  }
}
